import React from 'react';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
  tableOfContents?: React.ReactNode;
  currentPage?: string;
  onPageChange?: (page: string) => void;
}

const Layout: React.FC<LayoutProps> = ({ children, tableOfContents, currentPage = 'overview', onPageChange }) => {
  return (
    <div className="layout">
      {/* Header */}
      <header className="header">
        <div className="header-content">
          <div className="header-left">
            <h1 className="brand">lightswitch</h1>
            <div className="version-badge">
              <span className="version">v1.5.1</span>
              <span className="api-reference">📚 API Reference</span>
            </div>
          </div>
          <div className="header-right">
          </div>
        </div>
      </header>

      <div className="main-container">
        {/* Sidebar */}
        <aside className="sidebar">
          <nav className="navigation">
            <div className="nav-section">
              <h3 className="nav-section-title">OVERVIEW</h3>
              <ul className="nav-list">
                <li 
                  className={`nav-item ${currentPage === 'overview' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('overview')}
                >
                  Overview
                </li>
              </ul>
            </div>

            <div className="nav-section">
              <h3 className="nav-section-title">GETTING STARTED</h3>
              <ul className="nav-list">
                <li 
                  className={`nav-item ${currentPage === 'quickstart' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('quickstart')}
                >
                  Quickstart
                </li>
                <li 
                  className={`nav-item ${currentPage === 'provisioning' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('provisioning')}
                >
                  Provisioning
                </li>
              </ul>
            </div>

            <div className="nav-section">
              <h3 className="nav-section-title">ACCESS & PAYWALL SDK</h3>
              <ul className="nav-list">
                <li 
                  className={`nav-item ${currentPage === 'access-overview' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('access-overview')}
                >
                  Overview
                </li>
                <li 
                  className={`nav-item ${currentPage === 'react-quickstart' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('react-quickstart')}
                >
                  React Quickstart
                </li>
                <li 
                  className={`nav-item ${currentPage === 'concepts' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('concepts')}
                >
                  Concepts
                </li>
                <li 
                  className={`nav-item ${currentPage === 'flows' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('flows')}
                >
                  Flows
                </li>
                <li 
                  className={`nav-item ${currentPage === 'configuration' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('configuration')}
                >
                  Configuration
                </li>
                {/* <li 
                  className={`nav-item ${currentPage === 'events-callbacks' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('events-callbacks')}
                >
                  Events & Callbacks
                </li> */}
                <li 
                  className={`nav-item ${currentPage === 'troubleshooting' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('troubleshooting')}
                >
                  Error Handling & Troubleshooting
                </li>
                <li 
                  className={`nav-item ${currentPage === 'security' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('security')}
                >
                  Security Notes
                </li>
                <li 
                  className={`nav-item ${currentPage === 'testing-locally' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('testing-locally')}
                >
                  Testing Locally
                </li>
                <li 
                  className={`nav-item ${currentPage === 'copy-paste-templates' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('copy-paste-templates')}
                >
                  Copy-Paste Templates
                </li>
              </ul>
            </div>

            <div className="nav-section">
              <h3 className="nav-section-title">ANALYTICS</h3>
              <ul className="nav-list">
                <li 
                  className={`nav-item ${currentPage === 'analytics-quickstart' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('analytics-quickstart')}
                >
                  Tiny Analytics Quickstart
                </li>
                {/* <li 
                  className={`nav-item ${currentPage === 'default-events' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('default-events')}
                >
                  Default Events
                </li>
                <li 
                  className={`nav-item ${currentPage === 'dashboards-export' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('dashboards-export')}
                >
                  Dashboards & Export
                </li> */}
              </ul>
            </div>

            {/* <div className="nav-section">
              <h3 className="nav-section-title">ADMIN & DEVELOPER TOOLS</h3>
              <ul className="nav-list">
                <li 
                  className={`nav-item ${currentPage === 'admin-basics' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('admin-basics')}
                >
                  Admin Basics
                </li>
                <li 
                  className={`nav-item ${currentPage === 'test-mode' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('test-mode')}
                >
                  Test Mode
                </li>
              </ul>
            </div> */}

            {/* <div className="nav-section">
              <h3 className="nav-section-title">ADVANCED TOPICS</h3>
              <ul className="nav-list">
                <li 
                  className={`nav-item ${currentPage === 'supabase-integration' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('supabase-integration')}
                >
                  Supabase Integration Details
                </li>
                <li 
                  className={`nav-item ${currentPage === 'multi-tenant-setup' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('multi-tenant-setup')}
                >
                  Multi-Tenant Setup (SaaS)
                </li>
                <li 
                  className={`nav-item ${currentPage === 'migrating' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('migrating')}
                >
                  Migrating from Clerk/RevenueCat
                </li>
              </ul>
            </div>

            <div className="nav-section">
              <h3 className="nav-section-title">REFERENCE</h3>
              <ul className="nav-list">
                <li 
                  className={`nav-item ${currentPage === 'rest-api' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('rest-api')}
                >
                  REST API
                </li>
                <li 
                  className={`nav-item ${currentPage === 'sdk-reference' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('sdk-reference')}
                >
                  SDK Reference (JS/Python)
                </li>
                <li 
                  className={`nav-item ${currentPage === 'event-schemas' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('event-schemas')}
                >
                  Event Schemas
                </li>
              </ul>
            </div> */}

            {/* <div className="nav-section">
              <h3 className="nav-section-title">FAQ</h3>
              <ul className="nav-list">
                <li 
                  className={`nav-item ${currentPage === 'faq' ? 'active' : ''}`}
                  onClick={() => onPageChange?.('faq')}
                >
                  FAQ
                </li>
              </ul>
            </div> */}
          </nav>


        </aside>

        {/* Main Content */}
        <main className="content">
          {children}
        </main>

        {/* Table of Contents */}
        {tableOfContents && (
          <aside className="toc-sidebar">
            <div className="toc-header">TABLE OF CONTENTS</div>
            {tableOfContents}
          </aside>
        )}
      </div>
    </div>
  );
};

export default Layout; 